// Canonical heritage taxonomy — the single source for the tradition/topic
// vocabulary shared by the creator composer, subscriber onboarding, and content
// cards. The admin-managed `categories` table is a separate browse taxonomy and
// is not sourced from here.

export const TRADITIONS = [
  'anglo-saxon',
  'celtic',
  'norse',
  'germanic',
  'slavic',
  'mediterranean',
  'iberian',
  'hellenic',
  'baltic',
  'frankish',
] as const;

export const TOPICS = [
  'history',
  'art',
  'philosophy',
  'folk-life',
  'architecture',
  'language',
] as const;

export type Tradition = (typeof TRADITIONS)[number];
export type Topic = (typeof TOPICS)[number];

/** Slug → human label for every tradition and topic. */
export const TAXONOMY_DISPLAY: Record<string, string> = {
  'anglo-saxon': 'Anglo-Saxon',
  celtic: 'Celtic',
  norse: 'Norse',
  germanic: 'Germanic',
  slavic: 'Slavic',
  mediterranean: 'Mediterranean',
  iberian: 'Iberian',
  hellenic: 'Hellenic',
  baltic: 'Baltic',
  frankish: 'Frankish',
  history: 'History',
  art: 'Art',
  philosophy: 'Philosophy',
  'folk-life': 'Folk Life',
  architecture: 'Architecture',
  language: 'Language',
};
